import { Space, Row, Col, Button, Typography, Drawer } from "antd";
import Logo from "../../../assets/EasebuzzLogo-Black.png";
// import "./textSqlHeader.css";
import { useState } from "react";
import { CloseIcon,StripIcon } from "../../../shared/utils";

const { Text } = Typography;

export const TextSqlHeader = ({ handleClearAll }) => {
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };
  return (
    <Row justify="space-evenly" align={"middle"} className="ebz-header">
      <Col>
        <a href="https://easebuzz.in/" target="blank">
          <img src={Logo} alt="Easebuzz Logo" id="easebuzz-logo" />
        </a>
      </Col>
      <Col className="strip-drawer-col">
        <StripIcon onClick={handleDrawerOpen} />
        <Drawer
          title={
            <a href="https://easebuzz.in/" target="blank">
              <img src={Logo} alt="Easebuzz Logo" id="easebuzz-logo" />
            </a>
          }
          open={open}
          closeIcon={false}
          className="stip-drawer"
          mask={false}
          width={500}
          extra={
            <CloseIcon onClick={handleDrawerOpen} className="close-icon" />
          }
        >
          <Menu layout={"vertical"} align={"left"} ToHome={handleClearAll} />
        </Drawer>
      </Col>
      <Col className="no-strip-drawer-col">
        <Menu layout={"horizontal"} align={"center"} ToHome={handleClearAll} />
      </Col>
    </Row>
  );
};

const Menu = ({ layout, align, ToHome }) => {
  return (
    <Space direction={layout} size={45} align={align}>
      <Text onClick={() => ToHome()} className="text-light">
        Home
      </Text>
      <a
        href="https://era.easebuzz.in/"
        target="blank"
        className="text-light"
      >
        ERA
      </a>
      <a
        href="https://era.easebuzz.in/jiragenie"
        target="blank"
        className="text-light"
      >
        JiraGenie
      </a>
      <a
        href="https://era.easebuzz.in/buzzbucket"
        target="blank"
        className="text-light"
      >
        BuzzBucket
      </a>
      {layout === "vertical" && (
        <a
          href="https://docs.easebuzz.in/"
          className="text-light"
          target="blank"
        >
          Knowledge Base
        </a>
      )}
    </Space>
  );
};

